import './banner.css'

const Banner = ({data}) => {

      const BANNER_DEFAULT = "https://i.postimg.cc/08xg0Jgv/banner-bg.jpg"

      return (
            <div className="banner_content">
                  <img 
                  src={(data.data || data.length === 0) ? BANNER_DEFAULT : data[0].image} 
                  alt={(data.data || data.length === 0) ? "Banner Default" : data[0].title} />
            </div>
      )
}

export default Banner
